import getCountryFromURL from "./getCountryFromUrl";
function convertPhoneNumber(phoneNumber) {
  const country = getCountryFromURL();
  if (country === "AU") {
    if (phoneNumber.startsWith("0")) {
      return "+61" + phoneNumber.slice(1);
    } else if (phoneNumber.startsWith("61")) {
      return phoneNumber;
    } else if (phoneNumber.startsWith("04") || phoneNumber.startsWith("4")) {
      return "+61" + phoneNumber;
    } else {
      return phoneNumber;
    }
  } else {
    if (phoneNumber.startsWith("0")) {
      return "+64" + phoneNumber.slice(1);
    } else if (phoneNumber.startsWith("64")) {
      return phoneNumber;
    } else if (phoneNumber.startsWith("02") || phoneNumber.startsWith("2")) {
      return "+64" + phoneNumber;
    } else {
      return phoneNumber;
    }
  }
}

export default convertPhoneNumber;
